export enum StatusProcessoTr {
  AGUARDANDO_PROGRAMACAO = 'AGUARDANDO_PROGRAMACAO',
  PROGRAMACAO_REALIZADA = 'PROGRAMACAO_REALIZADA',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  CANCELADO = 'CANCELADO',
  FINALIZADO_OPERACIONALMENTE = 'FINALIZADO_OPERACIONALMENTE',
  AUDITADO = 'AUDITADO',
  FINALIZADO_CONTABILMENTE = 'FINALIZADO_CONTABILMENTE',
}

export const StatusProcessoTrDescricao: Record<StatusProcessoTr, string> = {
  [StatusProcessoTr.AGUARDANDO_PROGRAMACAO]: 'Aguardando Programação',
  [StatusProcessoTr.PROGRAMACAO_REALIZADA]: 'Programação Realizada',
  [StatusProcessoTr.EM_ANDAMENTO]: 'Em Andamento',
  [StatusProcessoTr.CANCELADO]: 'Cancelado',
  [StatusProcessoTr.FINALIZADO_OPERACIONALMENTE]: 'Finalizado Operacionalmente',
  [StatusProcessoTr.AUDITADO]: 'Auditado',
  [StatusProcessoTr.FINALIZADO_CONTABILMENTE]: 'Finalizado Contabilmente',
};